import $ from 'jquery';
import 'what-input';
import 'pagepiling.js';


// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import './lib/foundation-explicit-pieces';


$(document).ready(function () {

    var Body = $('body');
    Body.addClass('preloader-site');
    
    $(document).foundation();
    
    $('#pagepiling').pagepiling({
        menu: '#menu',
        anchors: ['witamy', 'kontakt'],
        navigation: {
            'textColor': '#ccc',
            'bulletsColor': '#ccc',
            'position': 'right',
            'tooltips': ['Witamy', 'Kontakt']
        }
    });

    // setTimeout(function(){
    //     document.body.style.opacity="100";
    // },1000);


});

$(window).on('load', function() {
    $('.preloader-wrapper').fadeOut();
    $('body').removeClass('preloader-site');
});

